export default __webpack_public_path__ + "static/media/arrow-right.a504bd9c.svg";